import { useEffect, useState } from 'react';

export interface CareCueResponseDraft {
  noteId: string;
  groupId: string;
}

export type Draft<T extends Record<string, any> = { content: string }> = {
  type: 'CareCueResponse';
  defaultValue: T;
} & CareCueResponseDraft;

export interface DraftValueAndUtils<T> {
  value?: T;
  setValue: (value: T) => void;
  reset: () => void;
}

const useDraftStore = <T extends Record<string, any> = { content: string }>(
  draft: Draft<T>,
): DraftValueAndUtils<T> => {
  const [draftValue, setDraftValue] = useState<T>();
  const { type, defaultValue, ...typeSpecificProperties } = draft;

  const key = ['__draft__', type, ...Object.values(typeSpecificProperties)].join('.');

  const setValue = (value: T) => {
    localStorage.setItem(key, JSON.stringify(value));
    setDraftValue(value);
  };

  const reset = () => {
    setValue(defaultValue);
  };

  useEffect(() => {
    const storedValue = localStorage.getItem(key);
    if (storedValue) {
      setDraftValue(JSON.parse(storedValue));
    } else {
      setValue(defaultValue);
    }
  }, []);

  return { value: draftValue, setValue, reset };
};

export default useDraftStore;
